// 編集モード
export enum EditMode {
  Read,
  Edit,
  Add,
}
